import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { Router } from 'react-router-dom';
import ga from 'react-ga';
// import { ConnectedRouter } from 'react-router-redux';
import { renderRoutes } from 'react-router-config';
import { IntlProvider } from 'react-intl-redux';
// import { addLocaleData } from 'react-intl';
// import itLocaleData from 'react-intl/locale-data/it';
// import zhLocaleData from 'react-intl/locale-data/zh';
import createStore from './store/configureStore';
import * as serviceWorker from './serviceWorker';
import routes from './routes';
// addLocaleData([...itLocaleData, ...zhLocaleData]);
// const possibleLocale = preloadedState.intl.locale || 'en';
// addLocaleData(require(`react-intl/locale-data/${possibleLocale}`));

export const history = createBrowserHistory();
const store = createStore(history);

if (process.env.NODE_ENV === 'production') {
  ga.initialize('UA-114668907-1');
  history.listen(location => {
    ga.set({ page: location.pathname }); // Update the user's current page
    ga.pageview(location.pathname); // Record a pageview for the given page
  });
}

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider>
      <Router history={history}>{renderRoutes(routes)}</Router>
    </IntlProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
